
import {Vue, Component, ModelSync} from "vue-property-decorator";

@Component({})
export default class NavigationDrawer extends Vue {
  @ModelSync('open', 'change', { type: Boolean }) private readonly drawer = true;

}
